import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ServicesOverview } from '../components/ServicesOverview';
import { CompraVenta } from '../components/CompraVenta';
import { AlquilerApps } from '../components/AlquilerApps';
import { Consignacion } from '../components/Consignacion';
import { InversionesBanner } from '../components/InversionesBanner';
import { WhyUs } from '../components/WhyUs';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function Home() {
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-370">
      <Navbar data-id="element-371" />
      <main data-id="element-372">
        <Hero data-id="element-373" />
        <ServicesOverview data-id="element-374" />
        <CompraVenta data-id="element-375" />
        <AlquilerApps data-id="element-376" />
        <Consignacion data-id="element-377" />
        <InversionesBanner data-id="element-378" />
        <WhyUs data-id="element-379" />
        <Testimonials data-id="element-380" />
        <Contact data-id="element-381" />
      </main>
      <Footer data-id="element-382" />
      <FloatingWhatsApp data-id="element-383" />
    </div>;
}